import React, { useContext, useState } from 'react';
import LinkPlus from '../UI/LinkPlus.js';
import UserContext from '../../context/UserContext.js';
import BotoneraJugador from './BotoneraJugador.js';
import CampoEditableNumeroBlur from '../UI/campos/CampoEditableNumeroBlur.js';
import ComboSelectorJugador from '../UI/campos/ComboSelectorJugador.js';
import BotonImagen from '../UI/botones/BotonImagen.js';
import { ORDEN_TECNICOS } from '../Constants.js';
import { PersonaFormacion as Campos } from '../constantes/Campos.js';
import * as Funciones from '../funciones/FuncionesFormacion.js';
import * as FuncionesPersona from '../funciones/FuncionesPersona.js';
import * as Iconos from '../UI/Iconos.js';
import { Boton } from '../funciones/FuncionesFormacion.js';
import styles from './ParticipanteFormacion.module.css';

const ParticipanteFormacion = (props) => {
  const formacion = props.formacion;
  const plantel = props.plantel;
  const participante = props.participante;
  const cantSuplentes = props.cantSuplentes;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [editar, setEditar] = useState(false);
  const [modoPersonaSinId, setModoPersonaSinId] = useState(false);
  const [apellidoSinId, setApellidoSinId] = useState('');
  const [nombreSinId, setNombreSinId] = useState('');

  // Determinar si puede moverse arriba o abajo
  const participantesDelGrupo = formacion
    .filter((p) => p.titularidad === participante.titularidad)
    .sort((a, b) => a.orden - b.orden);

  const indiceEnGrupo = participantesDelGrupo.findIndex((p) => {
    if (participante.idPartidoFormacion > 0) {
      return p.idPartidoFormacion === participante.idPartidoFormacion;
    } else {
      return p.orden === participante.orden && p.titularidad === participante.titularidad;
    }
  });

  const puedeSubir = indiceEnGrupo > 0;
  const puedeBajar = indiceEnGrupo < participantesDelGrupo.length - 1;

  const onClickBoton = (boton) => {
    if (puedeEditar) {
      switch (boton) {
        case Boton.EDITAR: {
          setEditar(true);
          // Si hay personaSinId, activar modo edición de personaSinId
          if (participante.personaSinId) {
            setModoPersonaSinId(true);
            setApellidoSinId(participante.personaSinId.apellido || '');
            setNombreSinId(participante.personaSinId.nombre || '');
          }
          // Move focus to camiseta input
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (camisetaReference.current) {
                camisetaReference.current.focus();
              }
            });
          });

          break;
        }
        case Boton.CANCELAR: {
          setEditar(false);
          setModoPersonaSinId(false);
          setApellidoSinId('');
          setNombreSinId('');
          // Move focus to first editable input
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              focusFirstEditableOfCurrent();
            });
          });

          break;
        }
        case Boton.BORRAR: {
          setEditar(false);
          setModoPersonaSinId(false);
          setApellidoSinId('');
          setNombreSinId('');
          props.actualizarCampo(participante, Campos.PERSONA, null);
          if (participante.personaSinId) {
            props.actualizarCampo(participante, Campos.PERSONA_SIN_ID, null);
          }

          break;
        }
        default: {
          props.onClick(participante, boton);
        }
      }
    }
  };

  const onPersonaElegida = (persona) => {
    if (puedeEditar) {
      if (Funciones.ValidarPersonaLibre(formacion, participante, persona)) {
        setEditar(false);
        props.actualizarCampo(participante, Campos.PERSONA, persona);
      } else {
        alert('El participante ya está asignado a otra posición');
      }
    }
  };

  const onToggleModoPersonaSinId = () => {
    setModoPersonaSinId(!modoPersonaSinId);
    setApellidoSinId('');
    setNombreSinId('');
    // Move focus to first editable input
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        focusFirstEditableOfCurrent();
      });
    });
  };

  const onConfirmarPersonaSinId = () => {
    if (apellidoSinId.trim().length >= 2) {
      const personaSinId = {
        apellido: apellidoSinId.trim(),
        nombre: nombreSinId.trim(),
      };
      props.actualizarCampo(participante, Campos.PERSONA_SIN_ID, personaSinId);
      setEditar(false);
      setModoPersonaSinId(false);
      setApellidoSinId('');
      setNombreSinId('');
      // move focus to first editable input of the next participant in the list
      // Use requestAnimationFrame twice to ensure React finishes re-rendering
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          focusFirstEditableOfNext();
        });
      });
    } else {
      alert('Debe ingresar al menos 2 caracteres en el apellido');
    }
  };

  const camisetaReference = React.useRef(null);
  const filaRef = React.useRef(null);

  const focusFirstEditableOfCurrent = () => {
    try {
      if (filaRef.current) {
        const input = filaRef.current.querySelector('input');
        if (input) {
          input.focus();
        }
      }
    } catch (e) {
      console.error('focusFirstEditableOfCurrent: error', e);
    }
  };

  const focusFirstEditableOfNext = () => {
    try {
      if (!filaRef.current) {
        return;
      }

      // Go up to find the FormacionPartido container (we need to go up several levels)
      // The structure is: fila -> persona (div with styles.persona) -> Fragment/Section -> FormacionPartido container
      let container = filaRef.current;
      let nivelActual = 0;
      const maxNiveles = 10;

      // Go up until we find a container that has multiple [data-participante] elements
      while (container && nivelActual < maxNiveles) {
        container = container.parentElement;
        nivelActual++;

        if (container) {
          const participantesEnEsteNivel = container.querySelectorAll('[data-participante="true"]');

          if (participantesEnEsteNivel.length > 1) {
            // Found a container with multiple participants
            const allParticipantes = Array.from(participantesEnEsteNivel);
            const currentIndex = allParticipantes.indexOf(filaRef.current);

            if (currentIndex !== -1 && currentIndex + 1 < allParticipantes.length) {
              const nextParticipante = allParticipantes[currentIndex + 1];
              const input = nextParticipante.querySelector('input');

              if (input) {
                input.focus();
                return;
              }
            }
            return; // Exit after finding the right container level
          }
        }
      }
    } catch (e) {
      console.error('focusFirstEditableOfNext: error', e);
    }
  };
  const onCamisetaChange = (campo, valor) => {
    if (puedeEditar && valor && valor !== '') {
      if (Funciones.ValidarCamisetaJugador(formacion, participante, valor)) {
        props.actualizarCampo(participante, Campos.CAMISETA, valor);
      } else {
        camisetaReference.current.focus();
      }
    }
  };

  let campoJugador = '';
  if (puedeEditar) {
    // Verificar si tiene datos válidos
    const tienePersona = participante.persona && participante.persona.id;
    const tienePersonaSinId =
      participante.personaSinId &&
      participante.personaSinId.apellido &&
      participante.personaSinId.apellido.trim().length > 0;

    if ((tienePersona || tienePersonaSinId) && !editar) {
      if (tienePersona) {
        campoJugador = (
          <LinkPlus
            className={`${styles.link}`}
            to={'/persona/' + (participante.persona && participante.persona.id)}
            adaptativo={true}
          >
            {participante.persona
              ? FuncionesPersona.ApellidoNombrePuesto(participante.persona)
              : ''}
          </LinkPlus>
        );
      } else {
        campoJugador = (
          <div className={`${styles.link}`}>
            {participante.personaSinId
              ? FuncionesPersona.ApellidoNombreSinId(participante.personaSinId)
              : ''}
          </div>
        );
      }
    } else {
      if (modoPersonaSinId) {
        // Modo: Ingresar persona sin ID
        campoJugador = (
          <div className={`${styles.formPersonaSinId}`}>
            <input
              type="text"
              placeholder="Apellido"
              value={apellidoSinId}
              onChange={(e) => setApellidoSinId(e.target.value)}
              className={`${styles.inputPersonaSinId}`}
            />
            <input
              type="text"
              placeholder="Nombre"
              value={nombreSinId}
              onChange={(e) => setNombreSinId(e.target.value)}
              className={`${styles.inputPersonaSinId}`}
            />
            <BotonImagen
              name="confirmar"
              imagen={Iconos.aceptar}
              width="15px"
              height="15px"
              alt="Confirmar"
              onClick={onConfirmarPersonaSinId}
            />
            <BotonImagen
              name="cancelar"
              imagen={Iconos.personaSinIdCancelar}
              width="15px"
              height="15px"
              alt="Volver al combo"
              onClick={onToggleModoPersonaSinId}
            />
          </div>
        );
      } else {
        // Modo: Combo de selección
        const jugadores = plantel.filter(
          (item) => item.puesto === null || item.puesto.orden < ORDEN_TECNICOS
        );
        campoJugador = (
          <div className={`${styles.comboConBoton}`}>
            <ComboSelectorJugador
              lista={jugadores}
              valorActual={
                participante.persona
                  ? FuncionesPersona.ApellidoNombrePuesto(participante.persona)
                  : ''
              }
              onItemElegido={onPersonaElegida}
            />
            <BotonImagen
              name="personaSinId"
              imagen={Iconos.personaSinIdAgregar}
              width="15px"
              height="15px"
              alt="Ingresar persona sin ID"
              onClick={onToggleModoPersonaSinId}
            />
          </div>
        );
      }
    }
  } else {
    // Modo sin permiso de edición
    const tienePersona = participante.persona && participante.persona.id;
    const tienePersonaSinId =
      participante.personaSinId &&
      participante.personaSinId.apellido &&
      participante.personaSinId.apellido.trim().length > 0;

    if (tienePersona) {
      campoJugador = (
        <LinkPlus
          className={`${styles.link}`}
          to={'/persona/' + (participante.persona && participante.persona.id)}
          adaptativo={true}
        >
          {participante.persona ? FuncionesPersona.ApellidoNombrePuesto(participante.persona) : ''}
        </LinkPlus>
      );
    } else if (tienePersonaSinId) {
      campoJugador = (
        <div className={`${styles.link}`}>
          {FuncionesPersona.ApellidoNombreSinId(participante.personaSinId)}
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      {participante && campoJugador && (
        <div className={`${styles.fila}`} ref={filaRef} data-participante="true">
          {puedeEditar && props.onReordenar && (
            <div className={`${styles.flechasReorden}`}>
              <BotonImagen
                name="subirOrden"
                imagen={puedeSubir ? Iconos.cambioEntra : Iconos.cambioEntraDisabled}
                estiloImagen={styles.botonOrden}
                alt="Subir"
                onClick={() => puedeSubir && props.onReordenar(participante, 'arriba')}
                disabled={!puedeSubir}
              />
              <BotonImagen
                name="bajarOrden"
                imagen={puedeBajar ? Iconos.cambioSale : Iconos.cambioSaleDisabled}
                estiloImagen={styles.botonOrden}
                alt="Bajar"
                onClick={() => puedeBajar && props.onReordenar(participante, 'abajo')}
                disabled={!puedeBajar}
              />
            </div>
          )}
          <div className={`${styles.camiseta}`}>
            <CampoEditableNumeroBlur
              inputRef={camisetaReference}
              estilo={`${styles.campoCamiseta}`}
              editar={puedeEditar && (!participante.camiseta || editar)}
              nombre={Campos.CAMISETA}
              valor={participante.camiseta}
              onBlur={onCamisetaChange}
            />
          </div>
          <div className={`${styles.participante}`}>{campoJugador}</div>
          {puedeEditar && (
            <div className={`${styles.detalles} ${editar && styles.editar}`}>
              <BotoneraJugador
                participante={participante}
                editar={editar}
                cantSuplentes={cantSuplentes}
                onClickBoton={onClickBoton}
              />
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default ParticipanteFormacion;
